import IsLoading from "@/components/layouts/IsLoading"
import InstitutionContext from "@/contexts/data/InstitutionContext";
import { generateSlug } from "@/utils";
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router";

const InstitutionCanonicalRedirectPage = () => {
    const { data, error } = useContext(InstitutionContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (data) {
            navigate(`/${data.id}/${generateSlug(data.name ?? 'unknown')}`, { replace: true });
        }
        else if (error) {
            navigate(`/`);
        }
    }, [data, error, navigate])

    return (
        <IsLoading name="InstitutionCanonicalRedirect" loading={true} validating={false} />
    )
}

export default InstitutionCanonicalRedirectPage
